import { g as ze, _ as i, a as pe, b as He, P as e, d as Ye } from "./createTheme-6e68f5ca.js";
import * as l from "react";
import { g as Ge, s as _, u as qe, c as I, a as Ke, P as Xe, b as Po, d as Co, e as Ro, f as Oo, h as Mo, i as $o, G as Ue, j as G, k as Do } from "./Search-4d6031ad.js";
import { jsx as R, jsxs as Se } from "react/jsx-runtime";
function Lo(o) {
  return ze("MuiDivider", o);
}
const Ao = Ge("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), Go = Ao, No = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], Eo = (o) => {
  const {
    absolute: t,
    children: n,
    classes: u,
    flexItem: g,
    light: d,
    orientation: a,
    textAlign: m,
    variant: P
  } = o;
  return Ke({
    root: ["root", t && "absolute", P, d && "light", a === "vertical" && "vertical", g && "flexItem", n && "withChildren", n && a === "vertical" && "withChildrenVertical", m === "right" && a !== "vertical" && "textAlignRight", m === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, Lo, u);
}, Io = _("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (o, t) => {
    const {
      ownerState: n
    } = o;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: o,
  ownerState: t
}) => i({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (o.vars || o).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: o.vars ? `rgba(${o.vars.palette.dividerChannel} / 0.08)` : pe(o.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: o.spacing(2),
  marginRight: o.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: o.spacing(1),
  marginBottom: o.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: o
}) => i({}, o.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: o,
  ownerState: t
}) => i({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(o.vars || o).palette.divider}`
  }
}), ({
  theme: o,
  ownerState: t
}) => i({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(o.vars || o).palette.divider}`
  }
}), ({
  ownerState: o
}) => i({}, o.textAlign === "right" && o.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, o.textAlign === "left" && o.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), _o = _("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (o, t) => {
    const {
      ownerState: n
    } = o;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: o,
  ownerState: t
}) => i({
  display: "inline-block",
  paddingLeft: `calc(${o.spacing(1)} * 1.2)`,
  paddingRight: `calc(${o.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${o.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${o.spacing(1)} * 1.2)`
})), ce = /* @__PURE__ */ l.forwardRef(function(t, n) {
  const u = qe({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: g = !1,
    children: d,
    className: a,
    component: m = d ? "div" : "hr",
    flexItem: P = !1,
    light: O = !1,
    orientation: j = "horizontal",
    role: M = m !== "hr" ? "separator" : void 0,
    textAlign: W = "center",
    variant: k = "fullWidth"
  } = u, V = He(u, No), C = i({}, u, {
    absolute: g,
    component: m,
    flexItem: P,
    light: O,
    orientation: j,
    role: M,
    textAlign: W,
    variant: k
  }), $ = Eo(C);
  return /* @__PURE__ */ R(Io, i({
    as: m,
    className: I($.root, a),
    role: M,
    ref: n,
    ownerState: C
  }, V, {
    children: d ? /* @__PURE__ */ R(_o, {
      className: $.wrapper,
      ownerState: C,
      children: d
    }) : null
  }));
});
ce.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (ce.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: e.bool,
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: e.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   */
  light: e.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: e.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: e.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: e.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: e.oneOfType([e.oneOf(["fullWidth", "inset", "middle"]), e.string])
});
const qo = ce;
function jo(o) {
  return ze("MuiTooltip", o);
}
const Wo = Ge("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), v = Wo, ko = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function Vo(o) {
  return Math.round(o * 1e5) / 1e5;
}
const Bo = (o) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: u,
    touch: g,
    placement: d
  } = o, a = {
    popper: ["popper", !n && "popperInteractive", u && "popperArrow"],
    tooltip: ["tooltip", u && "tooltipArrow", g && "touch", `tooltipPlacement${Ye(d.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Ke(a, jo, t);
}, Fo = _(Xe, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (o, t) => {
    const {
      ownerState: n
    } = o;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: o,
  ownerState: t,
  open: n
}) => i({
  zIndex: (o.vars || o).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${v.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${v.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${v.arrow}`]: i({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${v.arrow}`]: i({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), Uo = _("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (o, t) => {
    const {
      ownerState: n
    } = o;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${Ye(n.placement.split("-")[0])}`]];
  }
})(({
  theme: o,
  ownerState: t
}) => i({
  backgroundColor: o.vars ? o.vars.palette.Tooltip.bg : pe(o.palette.grey[700], 0.92),
  borderRadius: (o.vars || o).shape.borderRadius,
  color: (o.vars || o).palette.common.white,
  fontFamily: o.typography.fontFamily,
  padding: "4px 8px",
  fontSize: o.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: o.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: o.typography.pxToRem(14),
  lineHeight: `${Vo(16 / 14)}em`,
  fontWeight: o.typography.fontWeightRegular
}, {
  [`.${v.popper}[data-popper-placement*="left"] &`]: i({
    transformOrigin: "right center"
  }, t.isRtl ? i({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : i({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${v.popper}[data-popper-placement*="right"] &`]: i({
    transformOrigin: "left center"
  }, t.isRtl ? i({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : i({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${v.popper}[data-popper-placement*="top"] &`]: i({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${v.popper}[data-popper-placement*="bottom"] &`]: i({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), So = _("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (o, t) => t.arrow
})(({
  theme: o
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: o.vars ? o.vars.palette.Tooltip.bg : pe(o.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let q = !1, ae = null, E = {
  x: 0,
  y: 0
};
function K(o, t) {
  return (n) => {
    t && t(n), o(n);
  };
}
const Je = /* @__PURE__ */ l.forwardRef(function(t, n) {
  var u, g, d, a, m, P, O, j, M, W, k, V, C, $, ue, de, fe, me, he;
  const X = qe({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: ge = !1,
    children: J,
    components: B = {},
    componentsProps: T = {},
    describeChild: Qe = !1,
    disableFocusListener: Ze = !1,
    disableHoverListener: be = !1,
    disableInteractive: eo = !1,
    disableTouchListener: oo = !1,
    enterDelay: ve = 100,
    enterNextDelay: Te = 0,
    enterTouchDelay: to = 700,
    followCursor: Q = !1,
    id: ro,
    leaveDelay: we = 0,
    leaveTouchDelay: no = 1500,
    onClose: ye,
    onOpen: xe,
    open: Pe,
    placement: Ce = "bottom",
    PopperComponent: Z,
    PopperProps: w = {},
    slotProps: y = {},
    slots: F = {},
    title: b,
    TransitionComponent: io = Ue,
    TransitionProps: lo
  } = X, Re = He(X, ko), f = /* @__PURE__ */ l.isValidElement(J) ? J : /* @__PURE__ */ R("span", {
    children: J
  }), ee = Po(), so = ee.direction === "rtl", [p, Oe] = l.useState(), [oe, ao] = l.useState(null), U = l.useRef(!1), te = eo || Q, S = l.useRef(), z = l.useRef(), x = l.useRef(), Me = l.useRef(), [po, $e] = Co({
    controlled: Pe,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let h = po;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: r
    } = l.useRef(Pe !== void 0);
    l.useEffect(() => {
      p && p.disabled && !r && b !== "" && p.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [b, p, r]);
  }
  const re = Ro(ro), D = l.useRef(), H = l.useCallback(() => {
    D.current !== void 0 && (document.body.style.WebkitUserSelect = D.current, D.current = void 0), clearTimeout(Me.current);
  }, []);
  l.useEffect(() => () => {
    clearTimeout(S.current), clearTimeout(z.current), clearTimeout(x.current), H();
  }, [H]);
  const De = (r) => {
    clearTimeout(ae), q = !0, $e(!0), xe && !h && xe(r);
  }, Y = Oo(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (r) => {
      clearTimeout(ae), ae = setTimeout(() => {
        q = !1;
      }, 800 + we), $e(!1), ye && h && ye(r), clearTimeout(S.current), S.current = setTimeout(() => {
        U.current = !1;
      }, ee.transitions.duration.shortest);
    }
  ), ne = (r) => {
    U.current && r.type !== "touchstart" || (p && p.removeAttribute("title"), clearTimeout(z.current), clearTimeout(x.current), ve || q && Te ? z.current = setTimeout(() => {
      De(r);
    }, q ? Te : ve) : De(r));
  }, Le = (r) => {
    clearTimeout(z.current), clearTimeout(x.current), x.current = setTimeout(() => {
      Y(r);
    }, we);
  }, {
    isFocusVisibleRef: Ae,
    onBlur: co,
    onFocus: uo,
    ref: fo
  } = Mo(), [, Ne] = l.useState(!1), Ee = (r) => {
    co(r), Ae.current === !1 && (Ne(!1), Le(r));
  }, Ie = (r) => {
    p || Oe(r.currentTarget), uo(r), Ae.current === !0 && (Ne(!0), ne(r));
  }, _e = (r) => {
    U.current = !0;
    const s = f.props;
    s.onTouchStart && s.onTouchStart(r);
  }, je = ne, We = Le, mo = (r) => {
    _e(r), clearTimeout(x.current), clearTimeout(S.current), H(), D.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Me.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = D.current, ne(r);
    }, to);
  }, ho = (r) => {
    f.props.onTouchEnd && f.props.onTouchEnd(r), H(), clearTimeout(x.current), x.current = setTimeout(() => {
      Y(r);
    }, no);
  };
  l.useEffect(() => {
    if (!h)
      return;
    function r(s) {
      (s.key === "Escape" || s.key === "Esc") && Y(s);
    }
    return document.addEventListener("keydown", r), () => {
      document.removeEventListener("keydown", r);
    };
  }, [Y, h]);
  const go = $o(f.ref, fo, Oe, n);
  !b && b !== 0 && (h = !1);
  const ie = l.useRef(), bo = (r) => {
    const s = f.props;
    s.onMouseMove && s.onMouseMove(r), E = {
      x: r.clientX,
      y: r.clientY
    }, ie.current && ie.current.update();
  }, L = {}, le = typeof b == "string";
  Qe ? (L.title = !h && le && !be ? b : null, L["aria-describedby"] = h ? re : null) : (L["aria-label"] = le ? b : null, L["aria-labelledby"] = h && !le ? re : null);
  const c = i({}, L, Re, f.props, {
    className: I(Re.className, f.props.className),
    onTouchStart: _e,
    ref: go
  }, Q ? {
    onMouseMove: bo
  } : {});
  process.env.NODE_ENV !== "production" && (c["data-mui-internal-clone-element"] = !0, l.useEffect(() => {
    p && !p.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [p]));
  const A = {};
  oo || (c.onTouchStart = mo, c.onTouchEnd = ho), be || (c.onMouseOver = K(je, c.onMouseOver), c.onMouseLeave = K(We, c.onMouseLeave), te || (A.onMouseOver = je, A.onMouseLeave = We)), Ze || (c.onFocus = K(Ie, c.onFocus), c.onBlur = K(Ee, c.onBlur), te || (A.onFocus = Ie, A.onBlur = Ee)), process.env.NODE_ENV !== "production" && f.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${f.props.title}\` or the Tooltip component.`].join(`
`));
  const vo = l.useMemo(() => {
    var r;
    let s = [{
      name: "arrow",
      enabled: !!oe,
      options: {
        element: oe,
        padding: 4
      }
    }];
    return (r = w.popperOptions) != null && r.modifiers && (s = s.concat(w.popperOptions.modifiers)), i({}, w.popperOptions, {
      modifiers: s
    });
  }, [oe, w]), N = i({}, X, {
    isRtl: so,
    arrow: ge,
    disableInteractive: te,
    placement: Ce,
    PopperComponentProp: Z,
    touch: U.current
  }), se = Bo(N), ke = (u = (g = F.popper) != null ? g : B.Popper) != null ? u : Fo, Ve = (d = (a = (m = F.transition) != null ? m : B.Transition) != null ? a : io) != null ? d : Ue, Be = (P = (O = F.tooltip) != null ? O : B.Tooltip) != null ? P : Uo, Fe = (j = (M = F.arrow) != null ? M : B.Arrow) != null ? j : So, To = G(ke, i({}, w, (W = y.popper) != null ? W : T.popper, {
    className: I(se.popper, w == null ? void 0 : w.className, (k = (V = y.popper) != null ? V : T.popper) == null ? void 0 : k.className)
  }), N), wo = G(Ve, i({}, lo, (C = y.transition) != null ? C : T.transition), N), yo = G(Be, i({}, ($ = y.tooltip) != null ? $ : T.tooltip, {
    className: I(se.tooltip, (ue = (de = y.tooltip) != null ? de : T.tooltip) == null ? void 0 : ue.className)
  }), N), xo = G(Fe, i({}, (fe = y.arrow) != null ? fe : T.arrow, {
    className: I(se.arrow, (me = (he = y.arrow) != null ? he : T.arrow) == null ? void 0 : me.className)
  }), N);
  return /* @__PURE__ */ Se(l.Fragment, {
    children: [/* @__PURE__ */ l.cloneElement(f, c), /* @__PURE__ */ R(ke, i({
      as: Z ?? Xe,
      placement: Ce,
      anchorEl: Q ? {
        getBoundingClientRect: () => ({
          top: E.y,
          left: E.x,
          right: E.x,
          bottom: E.y,
          width: 0,
          height: 0
        })
      } : p,
      popperRef: ie,
      open: p ? h : !1,
      id: re,
      transition: !0
    }, A, To, {
      popperOptions: vo,
      children: ({
        TransitionProps: r
      }) => /* @__PURE__ */ R(Ve, i({
        timeout: ee.transitions.duration.shorter
      }, r, wo, {
        children: /* @__PURE__ */ Se(Be, i({}, yo, {
          children: [b, ge ? /* @__PURE__ */ R(Fe, i({}, xo, {
            ref: ao
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Je.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: e.bool,
  /**
   * Tooltip reference element.
   */
  children: Do.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: e.shape({
    Arrow: e.elementType,
    Popper: e.elementType,
    Tooltip: e.elementType,
    Transition: e.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: e.shape({
    arrow: e.object,
    popper: e.object,
    tooltip: e.object,
    transition: e.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: e.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: e.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: e.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: e.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: e.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: e.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: e.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: e.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: e.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: e.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: e.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: e.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: e.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: e.func,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: e.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: e.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: e.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: e.shape({
    arrow: e.object,
    popper: e.object,
    tooltip: e.object,
    transition: e.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: e.shape({
    arrow: e.elementType,
    popper: e.elementType,
    tooltip: e.elementType,
    transition: e.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: e.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: e.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: e.object
});
const Ko = Je;
export {
  qo as D,
  Ko as M,
  Go as d
};
//# sourceMappingURL=Tooltip-34b208dc.js.map
